<template>
    <div  v-if="($route.query.type==2 && $route.path !='/webenterprise/login')
    || $route.path =='/webenterprise/homePage' 
    || $route.path =='/webenterprise/cooperate' 
    || $route.path =='/webenterprise/newsInfo'
    || $route.path == '/webenterprise/enhelpList'
    || $route.path == '/webenterprise/enAbout'
    || $route.path == '/webenterprise/jobHunting'
    || $route.path == '/webenterprise/mobileCenter'
    || $route.path == '/webenterprise/searchCert'
    || $route.path == '/webenterprise/course'
    "
    class="topbar"
    >
        <div class="header-container-top"
            :class="[{ static: isFixed },{bgF:Bgcolor}]"
            v-if="isShow"
             @mouseover=" Bgcolor = true" 
             @mouseleave="scrollTop > 460? Bgcolor = true : Bgcolor = false"
        >
            <div class="header-container-box  flex align-cen">
            <div class="header-container-left">
                 <img :src="logoimg ? logoimg :require('../../assets/images/logo01.png')" alt="" class="sider-logo">
            </div>
            <div class="header-container-con">
                <div class="navList flex align-cen">
                    <div
                     v-for="(item, index) in navList"
                    :key="index"
                    class="list-coumln"
                    :class="index == activeIndex  ? 'active-color': ''"
                    @click="navigate(item.path, index)"
                     @mouseover="enter(index)" 
                     @mouseleave="leave(index)" 
                    >
                    {{item.navItem}}
                    <div v-if="index == 6">
                    <!-- 关于我们弹出层 -->
                 <div class="About" v-if="AboutShow"
                  @mouseleave="aboutleave" 
                 >
                    <div class="About-row">
                        <!-- <div class="About-coumln"  @click="openAbout(5)">
                        董事长致辞
                        </div> -->
                        <div class="About-coumln"  @click="openAbout(6)">
                        人才招聘
                        </div>
                        <div class="About-coumln"  @click="openAbout(7)">
                         了解和隆优化
                        </div>
                        <div class="About-coumln"  @click="openAbout(8)">
                       联系我们
                        </div>
                        <div class="About-coumln"  @click="openAbout(9)">
                        资质荣誉
                        </div>
                    </div>
                 </div>
                    </div>
                    </div>
                </div>
            </div>
                         <classTem
                     v-if="showClass"
                    :activeIndex="activeIndex"
                    @sendStatus="emitFun"
                    ></classTem>
            <!-- -->
            <div class="header-container-right mft"  v-if="!tokenAuth">
                <div class="right-btn flex align-cen">
                     <div class="right-login" @click="openLogin">登录</div>
                    <div class="trial" @click="openReg">免费试用</div>
                </div>
            </div>
            <div class="header-container-right mft" v-if="tokenAuth" style="margin-right:24px">
                <el-dropdown>
                <span class="el-dropdown-link flex align-cen" style="color:#fff;cursor: pointer;">
                 <img :src="user.avatar || require('../../assets/images/head.png')" alt="" class="mo-sider-logo">
                 {{user.name}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" v-if="type !=1">
                    <el-dropdown-item @click.native="openMan(false)"><i class="icon-al-laptop"></i> 进入后台</el-dropdown-item>
                     <el-dropdown-item @click.native="openSet"><i class="icon-al-cog"></i> 账号设置</el-dropdown-item>
                     <!-- <el-dropdown-item  @click.native="openOrder"><i class="icon-al-file"></i> 订单管理</el-dropdown-item> -->
                     <el-dropdown-item @click.native="loginout"><i class="icon-al-poweroff"></i> 退出登录</el-dropdown-item>
                </el-dropdown-menu>
                </el-dropdown>
            </div>
                        </div>
        </div>
        <!-- 移动端头部 -->
        <div class="mobile-header-container-top" v-if="isShow"
        :class="[{ mobilestatic: isFixed }]"
        >
            <div class="mobile-navigation flex align-cen">
             <div class="topbar-icon flex algin-cen"  @click="toggleMenu" v-if="$route.path != '/webenterprise/mobileCenter'">
                <i :class=" mobileIsShow ? 'icon-al-times-circle-fill': 'fa fa-bars'" v-if="!flag"></i>
            </div>
             <div class="topbar-icon flex algin-cen"  @click="$router.go(-1);" v-if="$route.path == '/webenterprise/mobileCenter'">
               <i class="el-icon-arrow-left"></i>
            </div>
            <div class="navigation-center">
                <img :src="logoimg ? logoimg :require('../../assets/images/HeroopSys.png')" alt="" class="sider-logo">
                <!-- <img src="../../assets/images/HeroopSys.png" alt="" class="sider-logo"> -->
            </div>
            <div class="navigation-right mft flex align-cen">
                <span class="pc-span" v-if="!tokenAuth">
                   <i class="fa fa-user-circle" v-if="!flag" @click="openMask(0)"></i>
                  <i class="el-icon-close" v-if="flag" @click="openMask(1)"></i>
                </span>
                 <span class="mo-span" v-if="tokenAuth">
                     <img :src="user.avatar || require('../../assets/images/head.png')" alt="" class="mo-sider-logo" v-if="!flag" @click="openMask(0)">
                     <i class="el-icon-close" v-if="flag" @click="openMask(1)"></i>
                 </span>
            </div>
            </div>
        </div>
        <!-- 移动端测边 -->
         <div class="rMenu" :class="{active:mobileIsShow}">
            <div class="channel-list  flex align-cen">
                 <div class="rMenu-left">
                <div class="channel-item">
                    <div class="channel-item-title" @click="openView(1,'homePage')">首页</div>
                     <div class="channel-item-title1">
                         <el-collapse 
                            v-model="activeName"
                            accordion
                            @change="collCH"
                            >
                             <el-collapse-item title="产品中心" name="1">
                                 <ul class="isSidebar-item">
                                    <li
                                     v-for="(item, index) in itemList"
                                     :key="index"
                                     :class="index == textActive  ? 'indexLi': ''"
                                     @click="gethisList(item.id,index)"
                                    >
                                          {{item.name}}   
                                    </li>
                                 </ul>
                             </el-collapse-item>
                         </el-collapse>
                     </div>
                       <div class="channel-item-title1">
                         <el-collapse 
                            v-model="activeName"
                            accordion
                            >
                             <el-collapse-item title="解决方案" name="2">
                                 <ul class="isSidebar-item">
                                    <li
                                     v-for="(item, index) in itemList1"
                                     :key="index"
                                      :class="index == text1Active  ? 'indexLi': ''"
                                       @click="gethisList1(item.id,index)"
                                    >
                                          {{item.name}}   
                                    </li>
                                 </ul>
                             </el-collapse-item>
                         </el-collapse>
                     </div>
                     <div class="channel-item-title" @click="openView(2,'cooperate')">项目案例</div>
                     <!-- <div class="channel-item-title" @click="openView(10,'course')">课程中心</div> -->
                     <div class="channel-item-title" @click="openView(6,'newsInfo')">新闻动态</div>
                     <div class="channel-item-title" @click="openView(4,'enhelpList')">帮助中心</div>
                      <div class="channel-item-title" @click="openView(5)" :class="mobileAbout ? 'aboutclass' : ''">关于我们</div>
                </div>
            </div>
            <div class="rMenu-cen"></div>
            <div class="rMenu-right">
               <div class="rightList">
                <div class="tab" v-if="activeName == '1'">
                      <el-collapse v-model="activeNames">
                        <el-collapse-item v-for="(item,index) in dataList" :key="item.id"  :name="item.id">
                            <template slot="title">
                                <div class="numlist-tit flex align-cen">
                                    <div class="tit-name">
                                      {{item.name || '默认'}}
                                    </div>
                                </div>
                            </template>
                            <div v-for="(childItem,childIndex) in item.applicationVOList" :key="childItem.id" class="childrenlist flex align-cen">
                               <div class="childrenlist-tit"
                               @click="openApp(childItem,1)"
                               >
                                 {{childItem.name}}
                               </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                  <div class="tab" v-if="activeName == '2'">
                    <div class="lsm-sidebar">
                     <div class="lsm-sidebar-item flex align-cen"
                     v-for="(item,index) in dataList1" :key="item.id"
                      @click="openApp(item,2)"
                     >
                      <span class="spri" 
                      :class="randomFun()"
                     ></span>
                       <p> {{item.name}}</p>
                    </div>
                    </div>
                  </div>
                     <!-- @click="openApp(item,2)" -->
                  <div class="tab" v-if="mobileAbout">
                      <div class="lsm-sidebar">
                     <div class="lsm-sidebar-item flex align-cen"
                        @click="openView(6,'jobHunting')"
                     >
                      <span class="spri icon-al-mail-fill" 
                  
                      ></span>
                       <p> 人才招聘</p>
                    </div>
                    <div class="lsm-sidebar-item flex align-cen"
                     @click="openView1(7)"
                     >
                      <span class="spri icon-al-paperplane-fill" ></span>
                       <p> 了解和隆优化</p>
                    </div>
                     <div class="lsm-sidebar-item flex align-cen"
                     @click="openView1(8)"
                     >
                      <span class="spri icon-al-headset-fill" ></span>
                       <p> 联系我们</p>
                    </div>
                     <div class="lsm-sidebar-item flex align-cen"
                     @click="openView1(9)"
                     >
                      <span class="spri icon-al-integral" ></span>
                       <p> 资质荣誉</p>
                    </div>
                    </div>
                  </div>
               </div>
            </div>
            </div>
         </div>
        <!-- 登录弹出层 -->
        <div class="loginmask" v-if="flag" @click.stop="openMask(1)">
            <div class="login-pop-box-inner" @click.stop>
                <div class="portal-box" v-if="tokenAuth">
                    <div class="portal-item-wrap">
                        <div class="portal-item" @click="openMan(true)">
                            进入后台
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>
                     <div class="portal-item-wrap">
                        <div class="portal-item" @click="openSet">
                            账号设置
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>
                     <!-- <div class="portal-item-wrap">
                        <div class="portal-item" @click="openOrder">
                                订单管理
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div> -->
                     <div class="portal-item-wrap">
                        <div class="portal-item" @click="loginout">
                            退出
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>
                </div>
                <div class="login-box flex align-cem" v-if="!tokenAuth">
                    <div class="sign-up-button" @click="openReg">免费试用</div>
                    <div class="login-button" @click="openLogin">登录</div>
                </div>
            </div>
        </div>
    </div>
</template> 
<script>
import LocaStorage from "../../utils/localstorage.js"
import { classList,ProductList,appTlist,enBusiness} from "@/api/enterprise/index" //分类，列表 、二级分类、查询企业列表
import { tokenOnline,pageList} from "@/api/enterprise/index" //检测token是否过期、配置列表
import classTem from "@/components/classTem/index.vue";  //多富文本组件
export default {
    inject: ["reload"],
    name:'enHeader',
    props: {
    type: [String, Number],
    },
    components:{
        classTem,
    },
    
    data () {
        return {
            mobileAbout:false,
            dataList1:[],
            text1Active:0,
             activeNames:[],
            dataList:[],
            textActive:0,
            activeName:['1'],
            mobileIsShow:false,
            scrollTop:0,
            Bgcolor:false,
            AboutShow:false,
            logoimg:'',
            showClass:false,
            activeIndex:0,
            isFixed:false,
            flag:false,
            tokenAuth:false,
            user:{},
            lotoken:'',
            isShow:true,
            fristId:'',
            fristId1:'',
            itemList:[],
            itemList1:[],
            navList:[
                {
                    path:'/webenterprise/homePage',
                    navItem:'首页'
                },{
                    path:'/webenterprise/enhelpdetail',
                    navItem:'产品'
                },{
                    path:'/',
                    navItem:'解决方案'
                },{
                    path:'/webenterprise/cooperate',
                    navItem:'项目案例'
                },
                {
                    path:'/webenterprise/newsInfo',
                    navItem:'新闻动态'
                },{
                    path:'/webenterprise/enhelpList',
                    navItem:'帮助中心'
                },{
                    path:'',
                    navItem:'关于我们'
                },
                {
                    path:'/webenterprise/searchCert',
                    navItem:'证书查询'
                }
            ]
        }
    },
    watch:{
         $route() {
          if(this.$route){
            if(this.$util.isMobile()){
                 this.gethisInfo()
        this.gethisInfo1()
            }
        this.lotoken = LocaStorage.setAge().get('token1')
         this.user =  LocaStorage.setAge().get('userinfo1')
          this.activeIndex = this.$route.meta.index;
         }
    }
    },

    created(){
                //         {
                //     path:'/webenterprise/course',
                //     navItem:'课程中心'
                // },
                // this.gethisInfo().then(res =>{
            //     this.gethisList(this.fristId,0)
            // })
            //  this.gethisInfo1().then(res =>{
            //     this.gethisList1(this.fristId1,0)
            // })
       //    异步同步执行
       if((this.$route.query.type == 2 && this.$route.path !='/webenterprise/login') 
       || this.$route.path =='/webenterprise/homePage'
       || this.$route.path =='/webenterprise/cooperate' 
       || this.$route.path =='/webenterprise/newsInfo'
       || this.$route.path == '/webenterprise/enhelpList'
       || this.$route.path == '/webenterprise/enAbout'
       || this.$route.path == '/webenterprise/jobHunting'){
        this.gethisInfo()
        this.gethisInfo1()
       }
        this.getLogo()
        this.getOnline()
            this.$bus.$off('Bgcolor')
  this.$bus.$on("Bgcolor", (msg,msg1) =>{   //vaPage传的时候的key是什么接收就必须是什么
     this.Bgcolor = msg
        this.scrollTop = msg1
   })
    this.$bus.$off('fixedState')
  this.$bus.$on("fixedState", msg =>{   //vaPage传的时候的key是什么接收就必须是什么
     this.isFixed = msg
   })
   this.$bus.$off('isShow')
  this.$bus.$on("isShow", msg =>{   //vaPage传的时候的key是什么接收就必须是什么
  this.isShow = msg
   })
//    监听登录兄弟组件登录状态
    this.$bus.$off('tokenStatus')
   this.$bus.$on("tokenStatus", msg =>{ 
   this.tokenAuth = msg
   })
   this.$bus.$off('isIndex')
    this.$bus.$on("isIndex", msg =>{ 
   this.activeIndex = msg
   })
   this.$bus.$off('isBanner')
    this.$bus.$on("isBanner", msg =>{ 
         this.reload();
   })
    },
    mounted(){
       this.activeIndex = this.$route.meta.index;
    },
    methods: {
        // 折叠面板切换
        collCH(){
          this.mobileAbout = false
        },
        // 打开页面
        openView(i,path){
            if(i == 5){
            this.activeName = []
            this.mobileAbout = true
            }else{
                this.mobileIsShow = false
                this.mobileAbout = false
                this.$bus.$emit("isOv", false);
                this.activeName = ['1']
                this.$router.push(`/webenterprise/${path}`)
            }
        },
           // 解决方案图标随机函数
        randomFun(){
            let Arr = ["icon-al-applicationgroup","icon-al-monitoring","icon-al-application","icon-al-databaseset-fill","icon-al-gallery-view","icon-al-Directory-tree"];
            let n = Math.floor(Math.random() * Arr.length + 1)-1;
            return Arr[n]
        },
        openView1(i){
            this.mobileAbout = false
            this.mobileIsShow = false
            this.$bus.$emit("isOv", false);
             this.activeName = ['1']
             this.$router.push(`/webenterprise/enAbout?type=${i}`)
             this.reload()
        },
        // 打开窗口
        openApp(data,i){
            this.mobileAbout = false
            this.mobileIsShow = false
            this.$bus.$emit("isOv", false);
             const newurl = this.$router.resolve({name: i == 1 ? 'endowloadDetail' : 'enSolution', query: {id: data.id,type:2}})
             window.open(newurl.href,'_blank')
             this.reload()
        },
            async gethisInfo(){
            await classList({},'enterprise',1)
            .then(res => {
              if(res.code == 0){
                 this.itemList = res.data
               this.fristId = res.data[0].id
               this.gethisList(res.data[0].id,0)
              }
            })
            .catch(err => {
            })
        },
           // 获取产品列表
        gethisList(id,index){
            this.textActive = index
            appTlist({id:id},'enterprise')
            .then(res =>{
                this.dataList = res.data
                this.activeNames.push(res.data[0].id)
            })
        },
          async gethisInfo1(){
            await classList({},'enterprise',2)
            .then(res => {
             if(res.code == 0){
               this.itemList1 = res.data
               this.fristId1 = res.data[0].id
               this.gethisList1(res.data[0].id,0)
             }
            })
            .catch(err => {
            })
        },
        // 获取解决方案列表
        gethisList1(id,index){
            this.text1Active = index
            ProductList({id:id},'enterprise',2)
            .then(res =>{
                this.dataList1 = res.data
                // console.log(this.dataList1)
            })
        },
        // 打开侧边栏
        toggleMenu(){
            if(this.mobileIsShow) this.activeName = ['1']
            this.mobileIsShow = !this.mobileIsShow
            this.$bus.$emit("isOv", this.mobileIsShow);
        },
        // 退出登录
        loginout(){
            localStorage.removeItem('token1')
            localStorage.removeItem('userinfo1')
            localStorage.removeItem('userinfo1')
            localStorage.removeItem('businessInfo')
            this.tokenAuth = false
        },
        // 打开企业后台
        openMan(isobile){
            // 手机点击进入后台时
            enBusiness({},'enterprise')
            .then(res =>{
                if(res.code == 0){
                     LocaStorage.setAge().set('officialType',1)
                 if(res.data.length == 1){
                  localStorage.removeItem('businessInfo')
                 LocaStorage.setAge().set('businessInfo',res.data[0])
                 
                        if(this.$util.isMobile()){
                            // 手机点击进入后台时
                            this.$router.push('/webenterprise/mobileCenter')
                        }else{
                            // pc点击进入后台时
                            const newurl = this.$router.resolve({path:'/webenterpriseManage/index', query: {}})
                            window.open(newurl.href,'_blank')
                        }
                }else{
                     if(this.$util.isMobile()){
                            // 手机点击进入后台时
                            this.$router.push('/webenterprise/enBusiness')
                        }else{
                            // pc点击进入后台时
                            const newurl = this.$router.resolve({name:'enBusiness', query: {}})
                 window.open(newurl.href,'_blank')
                        }
              
                }
                }else{
                     this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                }
            })
        },
        // 打开设置
        openSet(){
                const newurl = this.$router.resolve({name:'enSetting', query: {}})
                 window.open(newurl.href,'_blank')
        },
        // 打开关于我们
        openAbout(type){
           if(type == 5 || type == 7 || type == 8|| type == 9){
            this.$router.push({
                name:'enAbout',
                query:{
                    type:type
                }
            })
           }else{
            this.$router.push('/webenterprise/jobHunting')
           }
            this.reload()
           this.AboutShow = false
        },
        // 子组件触发
        emitFun(val,val1){
             this.showClass = false
             val1 ? this.activeIndex = val : this.activeIndex = this.$route.meta.index;
             val1 ? this.reload() : ''
            //  this.reload();
        },
        enter(i){
             this.activeIndex = i;
            if(i == 1 || i == 2){
                this.showClass = true
                 this.AboutShow = false
            } else if(i == 6){
                this.AboutShow = true
                 this.showClass = false
                }
            else{
                 this.AboutShow = false
                this.showClass = false
            }
        },
        leave(i){
            if(i ==1 || i ==2 || i ==6){
                
            }else{
                 this.activeIndex = this.$route.meta.index;
            }
             this.AboutShow = false
        },
        aboutleave(i){
             this.AboutShow = false
        },
        // 导航跳转
        navigate(path,index){
            this.activeIndex = index;
            if(index == 1 || index == 2){
                this.showClass = true
            }else if(index == 6){
                this.AboutShow = true
            }
            else{
                this.showClass = false
                 this.AboutShow = false
                this.$router.push(path)
            }
        },
        getOnline(){
              tokenOnline({},'enterprise')
                .then(res => {
                this.tokenAuth = true
                const token1 = LocaStorage.setAge().get('token1')
                    const userinfo1 = LocaStorage.setAge().get('userinfo1')
                    token1 ? this.tokenAuth = true : false
                this.user = userinfo1  || {}   
                })
                .catch(err => {
                    this.tokenAuth = false
                    if(err.code == 424){
                    localStorage.removeItem('token1')
					localStorage.removeItem('userinfo1')
                    }                   
                })
        },
        getLogo(){
              pageList({id:0},'enterprise')
                .then(res => {
                this.logoimg = res.data[0].attributeValue
                })
                .catch(err => {                  
                })
        },
        // 打开订单管理
        openOrder(){
        const newurl = this.$router.resolve({name:'orderAdmin', query: {id: this.$route.query.id}})
         window.open(newurl.href,'_blank')
            // this.$router.push({
            //     name:'orderAdmin',
            //      query: {
            //      id:this.$route.query.id,
            //     }
            // })
        },
        // 打开注册
        openReg(){
                let params = {
                type:1
            }
           if(this.$route.name == 'endowloadDetail') params.appId = this.$route.query.id
           if(this.$route.name == 'enSolution') params.solutionId = this.$route.query.id
           if(this.$route.name == 'cooperate') params.redirectUrl = 'cooperate'
              const newurl = this.$router.resolve({name:'register',  query:params})
             window.open(newurl.href,'_blank')
            //    this.$router.push({
            //      name: "register",
            //     query:{appId:this.$route.query.id,type:1}
            // })
        },
        // 打开登录
        openLogin(){
            let params = {
                id:this.$route.query.id,
                redirectUrl:this.$route.name,
                type:this.$route.query.id ? 2 : this.$route.query.type
            }
            const newurl = this.$router.resolve({name:'enLogin',  query:params})
             window.open(newurl.href,'_blank')
        //         this.$router.push({
        //     name:'enLogin',
        //     query: params
        //  })
        },
        // 打开登录遮招
        openMask(type){
            type == 0 ? this.flag = true : this.flag = false
             this.$emit('sendStatus', this.flag)
        }
    },
    destroyed(){
        this.$bus.$off('fixedState')
            this.$bus.$off('tokenStatus')
            this.$bus.$off('isShow')
    }
}
</script>
<style lang="scss" scoped>
.mobile-header-container-top{
    display: none;
}
.rMenu{
        display: none;
    }
// .topbar{
//         height: 64px;
// }
.header-container-top{
   background: rgba(255,255,255,.6);
    height: 64px;
    position: relative;
    z-index: 999;
    width: 100%;
    position: fixed;
     top: 0;
     .mo-sider-logo{
        border-radius: 50%;
        height: 30px;
     }
     .header-container-box{
        width: 80vw;
        margin: 0 auto;
        .header-container-con{
            position: relative;
            .About{
                width: 10vw;
                position: absolute;
                background: #fff;
                top: 64px;
                left:-1.3vw;
                .About-logo{
                    background: #f5f5f6;
                    height: 60px;
                    line-height: 60px;
                    padding-left: 20px;
                    img{
                        width: 120px;
                    }
                }
                .About-row{
                    text-align: center;
                    // justify-content: space-between;
                    .About-coumln{
                        width: 100%;
                       
                        cursor: pointer;
                         height: 40px;
                        line-height: 40px;
                        
                    }
                    .About-coumln:hover{
                        color: #2893f1;
                    }
                }
            }
            .navList{
                padding-left: 60px;
                position: relative;
                .list-coumln{
                    color: #181818;
                    font-size: 14px;
                    width: 7vw;
                    text-align: center;
                    cursor: pointer;
                    position: relative;
                    height: 64px;
                    line-height: 64px;
                }
                .active-color{
                    color: #181818;
                }
                .active-color::before{
                    content: '';
                    height: 3px;
                    width: 72px;
                    background:#2893f1;
                    position: absolute;
                    left: 50%;
                    bottom: 0px;
                    margin-left: -36px;
                }
            }
        }
     }
     .header-container-left{
        line-height: 64px;
        height: 64px;
            margin-left: 24px;
             margin-right: 24px;
            img{
                width: 120px;
                height: 40px;
            }
     }
     .header-container-right{
        img{
                width: 30px;
            margin-right: 10px;
        }
        .right-btn{
            height: 64px;
            margin-left: 24px;
             margin-right: 24px;
             color: #fff;
             .right-login{
                margin-right: 24px;
                cursor: pointer;
                color: #181818;
                font-size: 13px;
             }
           .trial{
            width: 68px;
            height: 24px;
            background: #2893f1;
            color: #fff;
            border-radius: 12px;
            cursor: pointer;
            font-size: 12px;
            text-align: center;
            line-height: 24px;
           } 
        }
     }
}
.static{
    position: relative;
    z-index: -1;
    display: none;
}
.bgF{
    background: #fff;
    backdrop-filter: none;
    box-shadow: 0 4px 15px rgba(0,0,0,.08);

}
@media (max-width: 1000px){
     	.rMenu{
        display: block !important;
		width: 100vw;
		height: calc(100% - 56px);
		position: fixed;
		left: 0;
		top: 56px;
		transform: translateX(-101vw);
		background: #fff;
		transition: transform 0.5s;
         box-shadow:3px 0px 5px rgba(0,0,0,.4);
         z-index: 999;
         .channel-list{
            height: 100%;
         }
      .rMenu-left{
        width: 140px;
        height: 100%;
        overflow-x: hidden;
       overflow-y: auto;
        background: #f7f8fc;
        .channel-item{
            width: 100%;
            box-sizing: border-box;
            overflow: hidden;
            position: relative;
            .channel-item-title{
                height: 40px;
                line-height: 40px;
                padding: 0 16px;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 14px;
                color: #1a1a1a;
            }
            .channel-item-title1{
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 14px;
                color: #1a1a1a;
              .el-collapse{
                    border-top: none;
                    border-bottom: none;
                }
                .isSidebar-item{
                    padding: 0 16px 0 32px;
                    li{
                     height: 40px;
                    line-height: 40px;
                    position: relative;
                    box-sizing: border-box;
                    display: block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    }
                    .indexLi{
                        color: #2893f1;;
                    }
                }
            }
            .aboutclass{
                color: #2893f1;
                position: relative;
            }
            .aboutclass::before{
            content: '';
            position: absolute;
            height: 16px;
            width: 4px;
            background: #2893f1;
            left: 0;
            top: 50%;
            margin-top: -8px;
        }
        }

    }
    .rMenu-cen{
    bottom: 0;
    top: 0;
    width: 10px;
    box-shadow: -3px 1px 3px 0 rgba(0,0,0,.03);
    height: 100%;
    }
    .rMenu-right{
        width: calc(100% - 150px);
        height: 100%;
         overflow-x: hidden;
       overflow-y: auto;
       .childrenlist{
        padding-left: 32px;
        font-size: 13px;
        color: #4e4e4e;
        letter-spacing: 0;
        line-height: 24px;
            padding-top: 8px;
        padding-bottom: 8px;
       }
       .lsm-sidebar{
        .lsm-sidebar-item {
            width: 100%;
    border-bottom: 1px solid #e2e2e2;
    display: flex;
    align-items: center;
    padding: 0 18px;
    height: 59px;
    line-height: 59px;
    span{font-size: 20px;}
    p{
        padding-left: 10px;
        overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    }
        }
       }
    }
	}
	.active{
		transform: translateX(0vw);
	}
    .ovlef{
        overflow: hidden;
    }
.header-container-top {
    display: none;
}
.mobile-header-container-top{
    display: block;
    height: 56px;
    position: relative;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
    position: fixed;
     top: 0;
     z-index: 999;
     width: 100%;
     background: #fff;
    .topbar-icon,.navigation-right{
     width: 50px;
    height: 56px;
    text-align: center;
    cursor: pointer;
    line-height: 56px;
 align-items: center;
    justify-content: center;
    i{
        font-size: 22px;
    }
    .mo-sider-logo{
        width: 30px;
        border-radius: 50%;
        height: 30px;
    }
    }
    .navigation-center{
        width: calc(100% - 112px);
        text-align: center;
        img{
            width: 88px;
        }
    }
}
.mobilestatic{
    position: relative !important;
    z-index: -1 !important;
    display: none !important;
}
.loginmask{
    width: 100%;
    height: calc(100vh - 56px);
    background: rgba(0,0,0,.6);
    position: fixed;
    top: 56px;
    z-index: 1000;
    .login-pop-box-inner{
        width: 100%;
        background: #fff;
        position: relative;
        z-index: 999;
        .portal-box{
            padding: 0 11px 14px;
         .portal-item-wrap{
            height: 49px;
            line-height: 49px;
            border-bottom: 1px solid #e2e2e2;
            .portal-item {
                display: block;
                padding: 0 6.5px;
                font-size: 14px;
                color: #272727;
                position: relative;
                i{
                    height: 50px;
                    line-height: 50px;
                    color: #737373;
                    position: absolute;
                    top: 0;
                    right: 5px;
                    font-weight: bold;
                }
            }
         }
         .portal-item-wrap:first-of-type{
            border-top: none;
         }
        }
        .login-box{
            justify-content: space-evenly;
            div{
                min-width: 140px;
                cursor: pointer;
                border: none;
                box-shadow: inset 0 0 1px 1px #181818;
                font-weight: 400;
                font-size: 15px; 
                text-align: center;
                vertical-align: middle;
                background-color: transparent;
                border-radius: 10px;
                margin-top: 10px;
                padding: 5px 0;
                margin-bottom: 30px;
            }
        }
    }
}
}
@media screen and (max-width: 1280px){
    .header-container-con{
        .navList{
            padding-left: 0 !important;
        }
    }
}
::v-deep{
    .el-dropdown-link{
        color: #181818 !important;
    }
    .rMenu-left{
          .el-collapse-item__header{
        background: none;
        padding: 0 16px;
        border: none;
    }
    .el-collapse-item__content {
        padding: 10px 0;
    }
    .el-collapse{
        .el-collapse-item__header.is-active{
            background: #fff;
            position: relative;
            color: #2893f1;
        }
        .el-collapse-item__arrow{
            display: none;
        }
       .el-collapse-item__header.is-active::before{
            content: '';
            position: absolute;
            height: 16px;
            width: 4px;
            background: #2893f1;
            left: 0;
            top: 50%;
            margin-top: -8px;
        }
    }
    }
    .rMenu-right{
             .el-collapse-item__header{
        background: none;
        padding: 0 16px;
        border: none;
    }
    .el-collapse{
        border: none;
    }
    .el-collapse-item__wrap{
        border:none
    }
    }
}
</style>